var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFilterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m21.09,2.72H2.91c-.24,0-.36.29-.19.46l7.59,7.86v9.92c0,.23.24.39.45.3l2.74-1.16c.12-.05.2-.17.2-.3v-8.76l7.59-7.86c.17-.17.04-.46-.19-.46Z"
})));
export default SvgFilterIcon;